import { api } from "boot/axios";
let cachedFiscal = null;
let cachedMarketStatus = null;
let marketStatusPromise = null;
let cacheMainMenu = {
  data: null,
  promise: null,
  favMenuPromise: null,
};

export default () => {
  //asOf
  const asOf = async () => {
    try {
      // const data = await api.get("/tools/as-of/");
      const data = "Tue Aug 29 2023 3:00:00 PM";

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //asOfLive
  const asOfLive = async () => {
    try {
      // const data = await api.get("/tools/as-of-live/");
      const data = "Tue Aug 29 2023 3:00:00 PM";

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Market Statue
  const marketStatus = async () => {
    try {
      const data = await api.get("/tools/market-status/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const marketStatusNew = async () => {
    const now = Date.now();

    if (cachedMarketStatus?.data && now - cachedMarketStatus?.data?.c < 0) {
      return cachedMarketStatus;
    }
    if (marketStatusPromise) {
      return marketStatusPromise;
    }
    try {
      marketStatusPromise = api.get("/tools/market/status/");
      const data = await marketStatusPromise;
      cachedMarketStatus = data;
      marketStatusPromise = null;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Android Version
  const getAndroidVersion = async () => {
    try {
      const data = await api.get("/tools/android-version/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Latest Fiscal Year Quarter
  const getLatestFiscalYearQuarter = async () => {
    if (cachedFiscal) {
      return cachedFiscal;
    }
    try {
      const data = await api.get("/latest-fiscal-year-quarter/");
      cachedFiscal = data;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const patchFavMenu = async (payload) => {
    try {
      const data = await api.post(`/site/fav-menu/${payload.id}/`, payload);
      return data;
    } catch {
      throw new Error(error);
    }
  };

  const getMainMenu = async () => {
    if (cacheMainMenu.data) {
      return cacheMainMenu.data;
    }

    if (cacheMainMenu.promise) {
      return cacheMainMenu.promise;
    }
    try {
      cacheMainMenu.promise = api.get("/site/main-menu/");
      const data = await cacheMainMenu.promise;
      cacheMainMenu.promise = null;
      cacheMainMenu.data = data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getFavMenu = async () => {
    if (cacheMainMenu.favMenuPromise) {
      return cacheMainMenu.favMenuPromise;
    }
    try {
      cacheMainMenu.favMenuPromise = api.get("/site/fav-menu/");
      const data = await cacheMainMenu.favMenuPromise;
      cacheMainMenu.favMenuPromise = null;
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    asOf,
    asOfLive,
    marketStatus,
    getAndroidVersion,
    marketStatusNew,
    getLatestFiscalYearQuarter,
    patchFavMenu,
    getMainMenu,
    getFavMenu,
  };
};
